module.exports = __webpack_public_path__ + "assets/img/swiper-border.ed795855.png";